import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const MAX_LENGTH = 30;

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left',
    color: `${theme.palette.secondary.main}`,
    fontSize: 14,
    fontFamily: 'CircularMed',
    [theme.breakpoints.up('xs')]: {
      paddingBottom: '7px',
      lineHeight: 1.2,
      fontSize: 16,
      borderBottom: ({ highlighted }) =>
        `2px ${
          highlighted ? theme.palette.secondary.main : 'transparent'
        } solid`,
      color: ({ highlighted }) =>
        `${
          !highlighted
            ? theme.palette.text.secondary
            : theme.palette.text.primary
        }`
    }
  }
}));

const MenuSectionsNavLinkLabel = ({ highlighted, children }) => {
  const classes = useStyles({ highlighted });
  return (
    <Typography classes={classes}>
      {children.length > MAX_LENGTH
        ? children.slice(0, MAX_LENGTH) + '...'
        : children}
    </Typography>
  );
};

MenuSectionsNavLinkLabel.defaultProps = {
  fullWidth: false
};
MenuSectionsNavLinkLabel.propTypes = {
  highlighted: PropTypes.bool,
  classes: PropTypes.shape({}),
  children: PropTypes.node
};

export default MenuSectionsNavLinkLabel;
